<template>
  <div class="group-list" v-if="group.length > 0">
    <div class="germany-inside">
      <div class="accordion-header">
        <span><slot name="txtAccordionHeader">Typ</slot><span class="d-none d-md-inline-block">{{countItems()}}</span></span>
        <div class="accordion-button-wrapper">
          <b-btn class="accordion-toggle" @click="visible = !visible">
            <slot name="btnToggleClosed" v-if="!visible">Öffnen</slot>
            <slot name="btnToggleOpen" v-if="visible">minimieren</slot>
          </b-btn>
        </div>
      </div>
      <div class="accordion-content">
        <b-collapse v-model="visible">
          <b-card>
            <div class="content">
              <ItemisedBillingList :itemised-bills="group_" :group-type="groupType_" :extra-data="extraData">
                <template v-for="slot in possibleChildSlotsFor('List')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
              </ItemisedBillingList>
            </div>
          </b-card>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>

import ItemisedBillingList from './ItemisedBillingList.vue'
import slotProxy from '../../../../../mixins/slotProxy'

export default {
  name: 'Accordion',
  components: {
    ItemisedBillingList
  },
  data () {
    return {
      visible: false
    }
  },
  mixins: [
    slotProxy()
  ],
  computed: {
    group_: function () {
      return this.group
    },
    groupType_: function () {
      return this.groupType
    }
  },
  props: {
    group: {
      type: Array,
      default: () => []
    },
    groupType: {
      type: String,
      default: 'normal'
    },
    extraData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    countItems () {
      const items = this.group_.length
      if (items > 1) {
        return items + ' Einträge'
      }
      if (items === 1) {
        return '1 Eintrag'
      }
      return null
    }
  }
}
</script>
